module.exports = __webpack_public_path__ + "media/images/sp/stores/karuizawa/karuizawa_concept_03-63918ad1f8b23fefffccbb685f061916.jpg";